import FilterPopover from "../../reservation_v2/filters/FilterPopover";
import useFilterParams from "../../reservation_v2/filters/useFilterParams";
import { ESIM_FILTER_KEYS as KEYS } from "./esimReservationFilters";
import { packageLabel, PackageList, ZoneList } from "./ZonePackageLists";

// Zone and package. The package list is the chosen zone's, so picking a zone clears the package,
// and the package chip stays disabled until there is a zone.
const FilterZonePackage = () => {
  const { get, set } = useFilterParams();
  const zoneId = get(KEYS.zoneId);
  const packageId = get(KEYS.packageId);
  const clearPackage = { [KEYS.packageId]: "", [KEYS.packageName]: "" };

  return (
    <>
      <FilterPopover
        label="Zona"
        value={zoneId ? get(KEYS.zoneName) || `#${zoneId}` : ""}
        onClear={() => set({ [KEYS.zoneId]: "", [KEYS.zoneName]: "", ...clearPackage })}
      >
        {(close) => (
          <ZoneList
            selected={zoneId}
            onPick={(zone) => {
              set({ [KEYS.zoneId]: `${zone.id}`, [KEYS.zoneName]: zone.name, ...clearPackage });
              close();
            }}
          />
        )}
      </FilterPopover>
      <FilterPopover
        label="Paketa"
        value={packageId ? get(KEYS.packageName) || `#${packageId}` : ""}
        disabled={!zoneId}
        disabledTitle="Zgjedh zonën më parë"
        onClear={() => set(clearPackage)}
      >
        {(close) => (
          <PackageList
            zoneId={zoneId}
            selected={packageId}
            onPick={(pkg) => {
              set({ [KEYS.packageId]: `${pkg.id}`, [KEYS.packageName]: packageLabel(pkg) });
              close();
            }}
          />
        )}
      </FilterPopover>
    </>
  );
};

export default FilterZonePackage;
